import React from "react";
import "./ImmigrationPricing.css";

const ImmigrationPricing = () => {
  const services = [
    {
      name: "Immigrant Visa – Family Petition",
      description: "Petition for a parent, child, or spouse to immigrate to the U.S.",
      fee: "$2,375",
      note: "USCIS filing fee not included",
    },
    {
      name: "Non-Immigrant Visa – Tourist (B1/B2)",
      description: "Assistance with applying for a U.S. visitor visa",
      fee: "$550",
      note: "Consular application fee not included",
    },
    {
      name: "Adjustment of Status (Green Card)",
      description: "Apply for permanent residency from within the U.S.",
      fee: "$2,735",
      note: "USCIS filing fee not included",
    },
    {
      name: "Green Card Renewal",
      description: "Renew an expired or expiring Permanent Resident Card (Form I-90)",
      fee: "$385",
      note: "USCIS filing fee not included",
    },
    {
      name: "Citizenship / Naturalization Application",
      description: "Prepare and file Form N-400 for U.S. citizenship",
      fee: "$385",
      note: "USCIS filing fee not included",
    },
    {
      name: "U.S. Passport Application",
      description: "Application assistance for a U.S. passport book and/or passport card",
      fee: "$100",
      note: "State Department fee not included",
    },
    {
      name: "DNA Test",
      description: "DNA testing for child/parent relationship confirmation",
      fee: "$1,225",
      note: "Includes sample collection and appointment at an AABB-accredited lab",
    },
  ];

  return (
    <div className="pricing-container">
      <h1 className="pricing-title">Immigration Services Pricing</h1>
      <table className="pricing-table">
        <thead>
          <tr>
            <th>Service</th>
            <th>Description</th>
            <th>Our Fee</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          {services.map((service, index) => (
            <tr key={index}>
              <td>{service.name}</td>
              <td>{service.description}</td>
              <td className="pricing-fee">{service.fee}</td>
              <td className="pricing-note">{service.note}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="pricing-disclaimer">
        *Fees cover document preparation, form filing assistance, and consultation. Government filing fees are billed separately.
      </p>
    </div>
  );
};

export default ImmigrationPricing;
